import { useEffect, useRef, useState } from "react";
import Footer from "../../../Sub/Footer";
import CommonHeader from "../../../Sub/CommonHeader";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  addCart,
  addCartUploadImg,
  otpVerification,
  sendOtp,
} from "../../../../reducers/commonReducer";
import { checkout, home } from "../../../../const";
import GotoTop from "../../../../Components/GotoTop";

const schema = yup.object().shape({
  phone: yup.string().required(),
  otp: yup
    .string()
    .required("OTP is required")
    .matches(/^\d{6}$/, "OTP must be exactly 6 digits"),
});

const VerifyOtp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formRef = useRef(null);
  const queryParameters = new URLSearchParams(window.location.search);
  const verifiUser = queryParameters.get("verifiUser");
  const [loading, setLoading] = useState(false);
  const { getSingleProductData } = useSelector((state) => state.commonReducer);

  const userImages = Array.from({
    length: +localStorage.getItem("customerImgLength") || 0,
  })
    .map((_, index) => {
      const key = `image${index + 1}`;
      const imageUrl = localStorage.getItem(key);
      return {
        key,
        imageUrl,
      };
    })
    .filter(({ imageUrl }) => imageUrl !== null);
//direct user login
  useEffect(() => {
    if (verifiUser === "true" && formRef.current) {
      formRef.current.submitForm();
    }
  }, [verifiUser]);
  // useEffect(() => {
  //   if (verifiUser === "true") {
  //     const interval = setInterval(() => {
  //       if (formRef.current) {
  //         formRef.current.submitForm();
  //         clearInterval(interval);
  //       }
  //     }, 100);
  //     return () => clearInterval(interval);
  //   }
  // }, [verifiUser]);

  return (
    <>
      <CommonHeader />
      {/* {!verifiUser === "true" ?  <Row>
        <Col className="text-center p-5">
          <Spinner animation="grow" />
        </Col>
       </Row> :  */}
      <div className="container-fluid">
        <div className="page-main p-5 mbl-pedding-10">
          {verifiUser === "false" && <>
          <div className="section__head d-md-flex justify-content-between mb-40">
            <div className="section__title">
              <h1>Verify OTP</h1>
            </div>
          </div>
          <Row>
            <Col md={8} className="m-auto text-center">
              <p className="text-danger">
                <b>Note:</b> We have sent OTP to your registered Phone. Kindly
                enter OTP to proceed.
              </p>
            </Col>
          </Row>
          </>}
          <Row>
            <Col md={4} className="m-auto">
              <Formik
                innerRef={formRef}
                validationSchema={verifiUser === "false" && schema}
                onSubmit={async (values) => {
                  setLoading(true);
                  const apiResp = await dispatch(otpVerification(values));
                  if (apiResp?.payload?.status) {
                    if (!localStorage.getItem("quantity")) {
                      navigate(home);
                    }
                    if (localStorage.getItem("quantity")) {
                      const cartResp = await dispatch(
                        addCart({
                          productType: getSingleProductData?.productType,
                          product: localStorage.getItem("product"),
                          quantity: localStorage.getItem("quantity"),
                          inputFields: JSON.parse(
                            localStorage.getItem("inputFields")
                          ),
                          extraInputFields: JSON.parse(
                            localStorage.getItem("extraInputFields")
                          ),
                          attributeid:
                            localStorage.getItem("attributeid") !== "undefined"
                              ? localStorage.getItem("attributeid")
                              : "",
                        })
                      );
                      if (cartResp?.payload?.status) {
                        if (getSingleProductData?.productType === "customize") {
                          const uploadimgRsp = await dispatch(
                            addCartUploadImg({
                              captureImageHtml:
                                localStorage.getItem("captureImageHtml"),
                              userimg: userImages,
                              id: cartResp?.payload?.cartid,
                              height: localStorage.getItem("printHeight"),
                              width: localStorage.getItem("printWidth"),
                              fontFamilies: JSON.parse(
                                localStorage.getItem("fontFamilies")
                              ),
                            })
                          );
                          if (uploadimgRsp?.payload?.status) {
                            localStorage.removeItem("captureImageHtml");
                            localStorage.removeItem("product");
                            localStorage.removeItem("quantity");
                            localStorage.removeItem("userimg");
                            localStorage.removeItem("inputFields");
                            localStorage.removeItem("extraInputFields");
                            localStorage.removeItem("printWidth");
                            localStorage.removeItem("printHeight");
                            navigate(checkout);
                          }
                        } else {
                          localStorage.removeItem("captureImageHtml");
                          localStorage.removeItem("product");
                          localStorage.removeItem("quantity");
                          localStorage.removeItem("userimg");
                          localStorage.removeItem("inputFields");
                          localStorage.removeItem("extraInputFields");
                          localStorage.removeItem("printWidth");
                          localStorage.removeItem("printHeight");
                          navigate(checkout);
                        }
                      }
                    }
                  }
                  setLoading(false);
                }}
                initialValues={{
                  phone: localStorage.getItem("phone"),
                  otp: "",
                  verifiUser: /true/.test(verifiUser),
                }}
              >
                {({ handleSubmit, handleChange, touched, values, errors }) => (
                  <Form className="container" onSubmit={handleSubmit}>
                    {(verifiUser === "true" && loading) ? (
                      <Row>
                        <Col className="text-center p-5">
                          <Spinner animation="grow" />
                        </Col>
                      </Row>
                    ) : (
                      <>
                        <Row className="mb-3">
                          <Col md={12} sm={12}>
                            <Form.Group controlId="validationFormik01">
                              <Form.Label>Enter OTP</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Please Enter OTP"
                                name="otp"
                                value={values.otp}
                                onChange={handleChange}
                                isInvalid={!!errors.otp}
                                className={
                                  errors.otp && touched.otp && "errors"
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.otp}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <p className="mb-2">
                              Didn't receive the OTP?
                              <span
                                onClick={() =>
                                  dispatch(
                                    sendOtp({
                                      phone: localStorage.getItem("phone"),
                                    })
                                  )
                                }
                              >
                                Resend OTP
                              </span>
                            </p>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md={12} sm={12}>
                            <Button
                              variant="success"
                              className="bg-thememain w-100"
                              type="submit"
                              disabled={loading ? true : false}
                            >
                              {loading ? (
                                <Spinner animation="grow" />
                              ) : (
                                `Verify OTP`
                              )}
                            </Button>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
      </div>
      {/* } */}
      <GotoTop />
      <Footer />
    </>
  );
};

export default VerifyOtp;
